<template lang="pug">
include ./../../../s-pug/mixin-footer
include /../../s-pug/mixin-icon

.Window(:class="{'is-menuOpen': isMenuOpen}")
   vue-snotify()
   Loading(v-if="showLoading")
   ._mb1._px1._py05._borderBottom-default._borderColor-grey-100._bg-white._flex._flex-justifySpaceBetween
      router-link._link-subtle._inlineBlock._textDecoration-none._flex-alignSelfCenter(to="/")
         span._fs-4._bold Good Remote
         span._fs-2._c-grey-500._ml1 Account
      div
         router-link.Btn.Btn--white._px1._py05.hide-bpMobileMenu(to="/user/settings" disabled) Account
         button.Btn.Btn--white._px1._py05.show-bpMobileMenu.SidebarToggle(@click="toggleMenu()")
            | Menu
            .SidebarToggle-icon._ml075: +icon({name: 'icon-menu'})
   .Container-outer(v-if="!isLoggingOut")
      .Underlay._cursor-pointer.show-bpMobileMenu(v-if="isMenuOpen" v-on:click="toggleMenu")
      NotificationEmailVerifying()
      //- NotificationEmailNotVerified(v-if="maker && maker.data && !maker.data.isEmailVerified && !emailToConfirm")
      .Container-inner
         .Main._pt075
            ._mb2
               h1._fs-4 {{accountPageHeading}}
               slot(name="header-content")
            slot
         .Sidebar._relative
            .AdminNav-container
               button.Sidebar-mobileX.show-bpMobileMenu(@click="toggleMenu()"): +icon({name: 'icon-close'})
               //- TODO
               //- Handle the company-level navigation
               //- .AdminNav(v-for="co in companies" :key="index")
               //-    .AdminNav-heading {{co.}}
               .AdminNav(v-if="companies" v-for="co in companies" :key="co.ref.id")
                  //- .AdminNav-heading {{co.data.name}}
                  router-link.AdminNav-item(:to="`/${co.data.slug.current}/manage/`")
                     .AdminNav-itemInner
                        ._flex._flex-alignItemsCenter
                           //- .AdminNav-navBtnIcon: +icon({name: 'icon-cog'})
                           .AdminNav-navBtnIcon: +icon({name: 'icon-home'})
                           //- div Manage company
                           div {{co.data.name}}
                  div(v-for="teamProfile in co.teamProfilesResolved") 
                     //- .AdminNav-heading Team: {{teamProfile.teamResolved.data.name}}
                     router-link.AdminNav-item(:to="`/${teamProfile.data.slug.current}/manage/`")
                        .AdminNav-itemInner
                           ._flex._flex-alignItemsCenter
                              .AdminNav-navBtnIcon: +icon({name: 'icon-user-couple'})
                              //- div Manage team
                              div Team: {{teamProfile.teamResolved.data.name}}
                  //- router-link.AdminNav-item.AdminNav-item--last(:to="`/profile-example/`")
                  //-    .AdminNav-itemInner
                  //-       ._flex._flex-alignItemsCenter
                  //-          .AdminNav-navBtnIcon: include /icons/icon-application.svg
                  //-          div View Profile
                  //-          .AdminNav-navBtnIcon.AdminNav-navBtnIcon--sup._alpha-30: include /icons/icon-external-window.svg
                  //- router-link.AdminNav-item.AdminNav-item--last(:to="`/${teamProfile.data.slug.current}/edit/`")
                  //-    .AdminNav-itemInner
                  //-       ._flex._flex-alignItemsCenter
                  //-          .AdminNav-navBtnIcon: include /icons/icon-edit.svg
                  //-          div Edit Profile
                  //-          .AdminNav-navBtnIcon.AdminNav-navBtnIcon--sup._alpha-30: include /icons/icon-external-window.svg
                  //-          //- .AdminNav-navBtnIcon._ml-auto._alpha-30: include /icons/icon-external-window.svg

               //- Note: The iteration variable here (`makerTeams`) is used instead of accessing it via 
               //- the Vuex object (`maker.teams`) to prevent things from breaking due to SSR.
               //- .AdminNav(v-if="teamProfiles" v-for="teamProfile in teamProfiles" :key="teamProfile.ref.id")
               //-    .AdminNav-heading {{teamProfile.teamResolved.data.name}}
               //-    router-link.AdminNav-item(:to="`/${teamProfile.data.slug.current}/manage/`")
               //-       .AdminNav-itemInner
               //-          ._flex._flex-alignItemsCenter
               //-             .AdminNav-navBtnIcon: include /icons/icon-cog.svg
               //-             div Manage team
               //-    router-link.AdminNav-item.AdminNav-item--last(:to="`/profile-example/`")
               //-       .AdminNav-itemInner
               //-          ._flex._flex-alignItemsCenter
               //-             .AdminNav-navBtnIcon: include /icons/icon-application.svg
               //-             div View Profile
               //-             .AdminNav-navBtnIcon.AdminNav-navBtnIcon--sup._alpha-30: include /icons/icon-external-window.svg
               //-    router-link.AdminNav-item.AdminNav-item--last(:to="`/${teamProfile.data.slug.current}/edit/`")
               //-       .AdminNav-itemInner
               //-          ._flex._flex-alignItemsCenter
               //-             .AdminNav-navBtnIcon: include /icons/icon-edit.svg
               //-             div Edit Profile
               //-             .AdminNav-navBtnIcon.AdminNav-navBtnIcon--sup._alpha-30: include /icons/icon-external-window.svg
               //-             //- .AdminNav-navBtnIcon._ml-auto._alpha-30: include /icons/icon-external-window.svg
               .AdminNav
                  .AdminNav-heading {{makerState.maker && makerState.maker.data && makerState.maker.data.email}}
                  //- router-link.AdminNav-item.AdminNav-item--last(to="/user/settings/")
                     .AdminNav-itemInner
                        ._flex._flex-alignItemsCenter
                           .AdminNav-navBtnIcon: include /icons/icon-widget-add.svg
                           div Teams
                  router-link.AdminNav-item(to="/user/settings/")
                     .AdminNav-itemInner
                        ._flex._flex-alignItemsCenter
                           .AdminNav-navBtnIcon: +icon({name: 'icon-identification'})
                           div Manage account
                  a.AdminNav-item(v-on:click="logOut")
                     .AdminNav-itemInner
                        ._flex._flex-alignItemsCenter
                           .AdminNav-navBtnIcon: +icon({name: 'icon-door-exit'})
                           div Log out
   +footer('account')
</template>

<style lang="sass" scoped>
// Note: it seems that files using this layout have access to these style classes... be careful of conflicts!
$w-container: 1200px
$bp-mobileMenu: 720px
.show-bpMobileMenu
   +above($bp-mobileMenu)
      display: none
.hide-bpMobileMenu
   display: none
   +above($bp-mobileMenu)
      display: inherit
// --------------------------------
.Container-outer
   max-width: $w-container
   width: 100%
   display: flex
   flex-direction: column
   flex-grow: 1
   +mx(auto)
   +px($s-1)
.Container-inner
   display: flex
.Main
   width: 100%
   +above($bp-mobileMenu)
      padding-left: $s-3
.Sidebar
   order: -1
   position: relative
.Sidebar-mobileX
   position: absolute
   left: 100%
   padding-top: $s-075
   padding-left: $s-075
   display: none
   .is-menuOpen &
      display: block
   svg
      width: 28px
      display: inherit
.AdminNav-container
   position: fixed
   +tb(0)
   left: 0
   z-index: 100
   +px($s-1)
   transform: translate3d(-100%, 0, 0)
   transition: transform .2s ease
   .is-menuOpen &
      transform: translate3d(0, 0, 0)
      background-color: $grey-050
   +above($bp-mobileMenu)
      background-color: transparent
      position: sticky
      top: $s-1
      +px(0)
      transform: none
.SidebarToggle
   margin-left: $s-05
   padding-right: $s-3
.SidebarToggle-icon
   svg
      width: 22px
      display: inherit
      .secondary
         fill: $light-blue-vivid-700
.AdminNav
   width: 200px
   align-self: flex-start
   margin-bottom: $s-2
   // overflow: hidden
.AdminNav-heading
   margin-top: $s-1
   +py($s-05)
   +px($s-05)
   margin-bottom: $s-025
   border-radius: $radius
   font-size: $fs-05
   color: $grey-500
   // background-color: $light-blue-vivid-050
   // color: $light-blue-vivid-900
.AdminNav-item
   display: block
   text-decoration: none
   // border: solid 1px $grey-200
   margin-bottom: -1px
.AdminNav-itemInner
   font-size: $fs-075
   +px($s-05)
   +py($s-05)
   margin-bottom: $s-025
   display: block
   border: solid 1px transparent
   cursor: pointer
   color: $grey-600
   border-radius: $radius
   &:hover,
   &:focus
      background-color: $grey-050
      color: $grey-700
   .router-link-active &
      border-color: $grey-300
      // background-color: $grey-050
      // background-color: $teal-050
      background-color: $light-blue-vivid-050
      color: $light-blue-vivid-900
      // z-index: 50
.AdminNav-navBtnIcon svg
   width: 18px
   display: inherit
   margin-right: $s-1
   .primary
      fill: lighten(#a5b3bb, 10)
   .secondary
      fill: $light-blue-vivid-700
.AdminNav-navBtnIcon--sup
   margin-top: -10px
   margin-left: 3px
   svg
      width: 12px
</style>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NotificationEmailVerifying from '~/components/NotificationEmailVerifying.vue'
import NotificationEmailNotVerified from '~/components/NotificationEmailNotVerified.vue'

export default {
   props: {
      accountPageHeading: {
         type: String,
      },
   },
   components: {
      NotificationEmailVerifying,
      NotificationEmailNotVerified,
   },
   data() {
      return {
         isClient: process.isClient,
         isMenuOpen: false,
         showLoading: false,
         isLoggingOut: false,
         emailToConfirm: this.$route.query.emailConfirmation,
         currentRouteKey: this.$route.fullPath,
         companies: undefined,
         teamProfiles: undefined,
      }
   },
   computed: {
      ...mapState(['makerState']),
      titleTag() {
         return this.$route.name === 'home' ? 'h1' : 'h2'
      },
   },
   methods: {
      toggleMenu() {
         this.isMenuOpen = !this.isMenuOpen
         console.log('toggle!')
      },
      logOut() {
         this.showLoading = true
         this.isLoggingOut = true
         return this.$store.dispatch('logOut').then(() => {
            this.$router.push('/')
         })
      },
   },
   mounted() {
      //- Note: This is here and used to prevent things from breaking due to SSR.
      this.teamProfiles = this.makerState.teamProfiles
      this.companies = this.makerState.companies
      console.log('this.companies: ', this.companies)
   },
}
</script>
